const REBUY_FAILSAFE_DELAY = 3000;
let rebuyFallbackTimer = null;
let rebuyFallbackEnabled = false;
let themeCartBindingsInitialized = false;

const isRebuySmartCartEnabled = () =>
  typeof window !== "undefined" &&
  Boolean(window.ENABLE_REBUY_CART) &&
  !rebuyFallbackEnabled;

function clearRebuyFallbackTimer() {
  if (!rebuyFallbackTimer) return;
  clearTimeout(rebuyFallbackTimer);
  rebuyFallbackTimer = null;
}

function enableThemeCartFallback() {
  if (rebuyFallbackEnabled) return;
  rebuyFallbackEnabled = true;
  window.ENABLE_REBUY_CART = false;
  if (document.body) {
    document.body.classList.add("rebuy-smartcart-fallback");
    document.body.classList.remove("rebuy-smartcart-enabled");
  }
  initializeThemeCartBindings();
}

function scheduleRebuyFallback() {
  if (rebuyFallbackTimer || rebuyFallbackEnabled) return;
  rebuyFallbackTimer = setTimeout(() => {
    rebuyFallbackTimer = null;
    enableThemeCartFallback();
    openCartDrawer();
  }, REBUY_FAILSAFE_DELAY);
}

function showRebuySmartCart() {
  if (!isRebuySmartCartEnabled()) return false;
  if (
    window.Rebuy &&
    window.Rebuy.SmartCart &&
    typeof window.Rebuy.SmartCart.show === "function"
  ) {
    window.Rebuy.SmartCart.show();
    clearRebuyFallbackTimer();
    return true;
  }
  return false;
}

function hideRebuySmartCart() {
  if (
    window.Rebuy &&
    window.Rebuy.SmartCart &&
    typeof window.Rebuy.SmartCart.hide === "function"
  ) {
    window.Rebuy.SmartCart.hide();
    clearRebuyFallbackTimer();
    return true;
  }
  return false;
}

// Reusable functions to bind events
function bindQuantityControls() {
  document
    .querySelectorAll(".cart-drawer-item__quantity-container")
    .forEach((container) => {
      const input = container.querySelector(".quantity-input");
      const increaseBtn = container.querySelector('[data-action="increase"]');
      const decreaseBtn = container.querySelector('[data-action="decrease"]');
      const removeBtn = container.querySelector(".remove-btn");

      const spinner = document.createElement("div");
      spinner.className = "spinner";
      spinner.innerHTML = `
      <svg class="spinner-icon" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"/>
      </svg>
    `;

      const setLoading = (state) => {
        increaseBtn.disabled = state;
        decreaseBtn.disabled = state;
      };

      increaseBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        const newQty = parseInt(input.value) + 1;

        setLoading(true);
        if (await updateCart(key, newQty))
          await refreshCartDrawer((scrollToTop = true));
      });

      decreaseBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        let currentQty = parseInt(input.value);
        const maxQty = parseInt(input.max);
        console.log(currentQty, maxQty);
        // if (currentQty > maxQty) currentQty = maxQty + 1;
        // if (currentQty <= 1) return;
        setLoading(true);
        if (await updateCart(key, currentQty - 1))
          await refreshCartDrawer((scrollToTop = true));
      });

      removeBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        removeBtn.disabled = true;
        removeBtn.innerHTML = `<span class="add-to-cart-spinner"></span>`;
        removeBtn.style.borderBottom = "none";
        if (await updateCart(key, 0)) await refreshCartDrawer();
      });
    });
}

function bindQuantityControlsUpsell() {
  document
    .querySelectorAll(".cart-drawer-item__quantity-container")
    .forEach((container) => {
      const input = container.querySelector(".quantity-input-upsell");
      const increaseBtn = container.querySelector(
        '[data-action="increase-upsell"]'
      );
      const decreaseBtn = container.querySelector(
        '[data-action="decrease-upsell"]'
      );

      increaseBtn?.addEventListener("click", async () => {
        const newQty = parseInt(input.value) + 1;
        const maxQty = parseInt(input.max);
        if (newQty <= maxQty || maxQty < 0) {
          input.value = newQty;
          decreaseBtn.disabled = false;
        }
        if (newQty >= maxQty && maxQty > 0) {
          increaseBtn.disabled = true;
        }
        bindAddToCartButtons();
      });

      decreaseBtn?.addEventListener("click", async () => {
        const newQty = parseInt(input.value) - 1;

        if (newQty >= 1) {
          input.value = newQty;
          increaseBtn.disabled = false;
        }
        if (newQty <= 1) {
          decreaseBtn.disabled = true;
        }
        bindAddToCartButtons();
      });
    });
}

function initializeThemeCartBindings() {
  if (themeCartBindingsInitialized) return;
  bindQuantityControls();
  updateShippingProgressBar();
  bindAddToCartButtons();
  bindQuantityControlsUpsell();
  themeCartBindingsInitialized = true;
}

function bindAddToCartButtons() {
  document
    .querySelectorAll(".cart-drawer-item__add-to-cart-btn")
    .forEach((btn) => {
      const variantId = btn.dataset.variantId;
      const input = document.querySelector(".quantity-input-upsell");
      const quantity = input?.value ? parseInt(input?.value) : 1;
      // Avoid duplicate listeners
      btn.removeEventListener("click", btn._boundHandler);

      // Define and store the handler
      const handler = async () => {
        if (!variantId) return;

        // Store original content to restore later
        const originalHTML = btn.innerHTML;

        // Add loading state
        btn.disabled = true;
        btn.innerHTML = `<span class="add-to-cart-spinner"></span>`;
        btn.style.borderBottom = "none";

        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: quantity }),
          });

          console.log(await res.json());
          await refreshCartDrawer();
        } catch (err) {
          console.log(err);
        } finally {
          // Restore original button
          btn.disabled = false;
          btn.innerHTML = originalHTML;
          btn.style.borderBottom = "";
        }
      };

      btn._boundHandler = handler;
      btn.addEventListener("click", handler);
    });
}

const cartIcon = document.querySelector(".js-drawer-open-cart");
if (cartIcon) {
  cartIcon.addEventListener("click", function (e) {
    e.preventDefault();
    openCartDrawer();
  });
}

function openCartDrawer(newCart = true) {
  if (isRebuySmartCartEnabled()) {
    if (showRebuySmartCart()) {
      return;
    }
    const handleSmartCartReady = () => {
      if (rebuyFallbackEnabled) return;
      if (!showRebuySmartCart()) {
        enableThemeCartFallback();
        openCartDrawer();
      } else {
        clearRebuyFallbackTimer();
      }
    };
    document.addEventListener(
      "rebuy:smartcart.ready",
      handleSmartCartReady,
      { once: true }
    );
    scheduleRebuyFallback();
    return;
  }
  initializeThemeCartBindings();
  if (newCart) {
    refreshCartDrawer();
  }
  setTimeout(() => {
    // Ensure overlay click functionality is bound after DOM updates
    bindOverlayClickHandler();
  }, 300); // Allow DOM to update before showing drawer
  const cartDrawer = document.getElementById("cartDrawer");
  const overlay = document.getElementById("cartDrawerOverlay");
  if (!cartDrawer || !overlay) return;
  cartDrawer.classList.add("open");
  overlay.classList.add("show");
  document.body.style.overflow = "hidden";

  // Add escape key handler
  document.addEventListener("keydown", handleEscapeKey);

  // Bind overlay click handler
  bindOverlayClickHandler();
}

// Handle escape key press
function handleEscapeKey(e) {
  if (e.key === "Escape") {
    closeCartDrawer();
  }
}

// Bind overlay click handler to close cart drawer
function bindOverlayClickHandler() {
  const overlay = document.getElementById("cartDrawerOverlay");
  if (overlay) {
    // Remove any existing event listeners to prevent duplicates
    overlay.removeEventListener("click", closeCartDrawer);
    // Add the event listener
    overlay.addEventListener("click", closeCartDrawer);
  }
}

function closeCartDrawer() {
  if (isRebuySmartCartEnabled()) {
    hideRebuySmartCart();
    return;
  }
  const cartDrawer = document.getElementById("cartDrawer");
  const overlay = document.getElementById("cartDrawerOverlay");
  if (!cartDrawer || !overlay) return;
  document.body.style.overflow = "";
  cartDrawer.classList.remove("open");
  overlay.classList.remove("show");

  // Remove event listeners to prevent memory leaks
  document.removeEventListener("keydown", handleEscapeKey);
  if (overlay) {
    overlay.removeEventListener("click", closeCartDrawer);
  }
}

function updateShippingProgressBar() {
  const shippingProgressContainer = document.getElementById(
    "cart-shipping-progress"
  );
  if (!shippingProgressContainer) return;

  const subtotal = parseFloat(shippingProgressContainer.dataset.cartSubtotal);
  const threshold = parseFloat(
    shippingProgressContainer.dataset.freeShippingThreshold
  );
  const preMessage = shippingProgressContainer.dataset.cartPreMessage;
  const postMessage = shippingProgressContainer.dataset.cartPostMessage;
  const remaining = Math.max(0, threshold - subtotal).toFixed(2);
  const percentage = Math.min(100, (subtotal / threshold) * 100).toFixed(1);

  const shippingMessage = document.getElementById("shippingRemaining");
  const pdpShippingMessage = document.getElementById("pdp-shipping-message");
  const progressBar = document.getElementById("progressBarFill");

  if (shippingMessage) {
    shippingMessage.textContent =
      remaining > 0
        ? preMessage?.replace("[remainingForGoalFormatted]", `$${remaining}`)
        : postMessage;
  }
  if (pdpShippingMessage) {
    pdpShippingMessage.textContent =
      remaining > 0 ? `Add $${remaining} more for free shipping!` : postMessage;
  }
  if (progressBar) progressBar.style.width = `${percentage}%`;
}

const cartDrawer = document.querySelector(".cart-drawer-container");
const getLineItemKey = (el) =>
  el.closest("[data-line-item-key]")?.dataset.lineItemKey;
const updateCart = async (lineKey, quantity) => {
  try {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity }),
    });
    return res.ok;
  } catch (error) {
    console.log(error);
  }
};

const restoreCartScroll = (cartScrollTop) => {
  const cartDrawer = document.getElementById("cartDrawer");
  if (cartDrawer) {
    cartDrawer.scrollTop = cartScrollTop;
  }
};

const refreshCartDrawer = async (scrollToTop) => {
  if (isRebuySmartCartEnabled()) return;
  const drawerElement = document.getElementById("cartDrawer");
  if (!drawerElement) return;
  const cartScrollTop = drawerElement.scrollTop;
  const res = await fetch(
    window.location.pathname + "?sections=new-cart-drawer"
  );
  const data = await res.json();
  if (data["new-cart-drawer"] && cartDrawer) {
    cartDrawer.innerHTML = data["new-cart-drawer"];
    document.getElementById("cartDrawer")?.classList.add("open");
    document.getElementById("cartDrawerOverlay")?.classList.add("show");
    document.body.style.overflow = "hidden";
    bindQuantityControls();
    updateShippingProgressBar();
    bindAddToCartButtons();
    bindQuantityControlsUpsell();
    // Rebind overlay click handler after DOM update
    bindOverlayClickHandler();
    // Re-add escape key handler
    document.addEventListener("keydown", handleEscapeKey);
    if (scrollToTop) {
      restoreCartScroll(cartScrollTop);
    }
    const cartCount = document.getElementById("cart-drawer-item-count")?.dataset
      ?.cartCount;
    const bubble = document.querySelector(".cart-link__bubble");
    if (bubble && cartCount) {
      //   bubble.innerText = cartCount;
      bubble.classList.toggle("cart-link__bubble--visible", cartCount > 0);
    }
    if (Number(cartCount) <= 0) {
      const pdpShippingMessage = document.getElementById(
        "pdp-shipping-message"
      );
      if (pdpShippingMessage) {
        pdpShippingMessage.textContent = "";
      }
    }
  }
};

// Initial bindings
if (!isRebuySmartCartEnabled()) {
  initializeThemeCartBindings();
}
